import { render, staticRenderFns } from "./EmailTemplateEditOverlay.vue?vue&type=template&id=7608edad&scoped=true&"
import script from "./EmailTemplateEditOverlay.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateEditOverlay.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateEditOverlay.vue?vue&type=style&index=0&id=7608edad&scoped=true&lang=scss&"
import style1 from "./EmailTemplateEditOverlay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7608edad",
  null
  
)

export default component.exports